import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { put } from "./../../helpers/api_helper";
import { CUSTOMER_UPDATE } from "../../helpers/url_helper";
import toastr from "toastr";

const EditCustomerModal = ({ isOpen, toggle, customerData, onUpdated }) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      phone_no: "",
      name: "",
      Discount: "",
      notes: "",
      status: "1",
      address: "",
    },
  });

  useEffect(() => {
    if (customerData) {
      reset(customerData);
    }
  }, [customerData, reset]);

  const onSubmit = async (data) => {
    try {
      await put(CUSTOMER_UPDATE(customerData.ul_id), data);
      toastr.success("Customer updated successfully!");
      toggle();
      onUpdated();
    } catch (error) {
      console.error("Error updating customer", error);
      toastr.error("Failed to update customer.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal custom-modal-lg">
        <div className="custom-modal-header">
          <span>Edit Customer</span>
          <button type="button" className="close-btn" onClick={toggle}>
            &times;
          </button>
        </div>
        <div className="custom-modal-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-6 col-xl-4 mb-3">
                <label htmlFor="phone">
                  Phone No <span className="text-danger">*</span>
                </label>
                <Controller
                  name="phone"
                  control={control}
                  rules={{
                    required: "Phone number is required",
                    pattern: {
                      value: /^[0-9]*$/,
                      message: "Please enter only numbers",
                    },
                    minLength: {
                      value: 10,
                      message: "Must be 10-digits phone number",
                    },
                    maxLength: {
                      value: 10,
                      message: "Must be 10-digits phone number",
                    },
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      id="phone"
                      placeholder="Enter Phone no"
                      type="tel"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength="10"
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]|Backspace|ArrowLeft|ArrowRight|Tab|Delete/.test(
                            e.key
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      className={`form-control ${
                        errors.phone ? "is-invalid" : ""
                      }`}
                    />
                  )}
                />
                {errors.phone_no && (
                  <div className="text-danger">{errors.phone_no.message}</div>
                )}
              </div>
              <div className="col-md-6 col-xl-4 mb-3">
                <label htmlFor="name">Name</label>
                <Controller
                  name="name"
                  control={control}
                  rules={{ required: "Name is required" }}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      id="name"
                      placeholder="Enter name"
                      className="form-control"
                    />
                  )}
                />
              </div>
              <div className="col-md-6 col-xl-4 mb-3">
                <label htmlFor="Discount">Discount</label>
                <Controller
                  name="discount"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Enter Discount"
                      className="form-control"
                    />
                  )}
                />
              </div>
              <div className="col-md-6 col-xl-4 mb-3">
                <label htmlFor="Credit Balance">Credit Balance</label>
                <Controller
                  name="credit_balance"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Enter Balance"
                      className="form-control"
                    />
                  )}
                />
              </div>
              <div className="col-md-6 col-xl-4 mb-3">
                <label htmlFor="customer_status">Status</label>
                <Controller
                  name="status"
                  control={control}
                  render={({ field }) => (
                    <select
                      {...field}
                      id="customer_status"
                      className="form-select"
                    >
                      <option value="">Select Status</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  )}
                />
              </div>
              <div className="col-md-12 col-xl-8 mb-3">
                <label htmlFor="remarks">Remarks</label>
                <Controller
                  name="notes"
                  control={control}
                  render={({ field }) => (
                    <textarea
                      {...field}
                      placeholder="Enter notes"
                      className="form-control"
                    />
                  )}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={toggle}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
      <style>{`
        .custom-modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.5);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .custom-modal {
          background: #fff;
          border-radius: 8px;
          width: 90%;
          max-width: 900px;
          box-shadow: 0 2px 16px rgba(0,0,0,0.2);
        }
        .custom-modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          border-bottom: 1px solid #eee;
        }
        .custom-modal-body {
          padding: 1rem;
        }
        .close-btn {
          background: none;
          border: none;
          font-size: 2rem;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default EditCustomerModal;
